import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LaunchDialogService } from '@spartacus/storefront';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-waygate-rma-product-login-account-modal',
  standalone: false,
  templateUrl: './waygate-rma-product-login-account-modal.component.html',
  styleUrl: './waygate-rma-product-login-account-modal.component.scss'
})
export class WaygateRmaProductLoginAccountModalComponent implements OnInit, OnDestroy
{
  private destroy$=new Subject<void>();
  constructor(
  private lanchDialogService: LaunchDialogService,
  private router: Router,
  private route: ActivatedRoute
  ){}

ngOnInit(): void {
  
}
  signIn(): void {
    this.router.navigateByUrl('/login');
  this.lanchDialogService.closeDialog('signIn');
}

continueAsGuest(): void {
  this.lanchDialogService.closeDialog('guest');
  
}

register(): void {
  this.router.navigateByUrl('/waygate/register');
  this.lanchDialogService.closeDialog('register');

}
 
closeModal(): void {
  this.lanchDialogService.closeDialog('close');
}
ngOnDestroy(): void {
  this.destroy$.next();
  this.destroy$.complete();
}

}

